module.exports = __webpack_public_path__ + "4b95d897315a30ba3aa13e1badecfcbf.png";